import React, { Dispatch, FC } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { SetDraftResponse } from 'api/Responses/SetResponses';
import InputField from 'components/InputField';
import Label from 'components/Label/Label';
import { useLanguage } from 'context/AppContext';
import * as Styles from 'pages/Set/SetPage.styles';
import { draftActions, SetAction } from 'reducers/DraftReducer/draftActions';
import SetManual from './SetManual';
import SubTableWrapper from './SubTableWrapper';
import MemoizedTrayTable from './TrayTable';

interface SetTableProps {
  set: SetDraftResponse;
  dispatchSet: Dispatch<SetAction>;
  disabled: boolean;
}

const SetTable: FC<SetTableProps> = ({ set, dispatchSet, disabled }) => {
  const { code, display_code, revision, region, jme_group, name } = set;
  const [language] = useLanguage();

  return (
    <Table stickyHeader className="set-table">
      <TableHead>
        <TableRow id={code}>
          <TableCell>{display_code}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            <Styles.SetBody>
              <Styles.SetRow>
                <Label text={language.SetTable.code}>
                  <InputField variant="outlined" value={display_code} disabled />
                </Label>
                <Label text={language.SetTable.revision}>
                  <InputField
                    variant="outlined"
                    value={revision}
                    onChange={e => dispatchSet(draftActions.revision(e.target.value))}
                    disabled={disabled}
                  />
                </Label>
                <SetManual set={set} dispatchSet={dispatchSet} disabled={disabled} />
              </Styles.SetRow>
              <Styles.SetRow>
                <Label text={language.SetTable.name}>
                  <InputField
                    variant="outlined"
                    value={name}
                    onChange={e => dispatchSet(draftActions.name(e.target.value))}
                    disabled={disabled}
                  />
                </Label>
                <Label text={language.SetTable.region}>
                  <InputField
                    variant="outlined"
                    value={region}
                    onChange={e => dispatchSet(draftActions.region(e.target.value))}
                    disabled={disabled}
                  />
                </Label>
                <Label text={language.SetTable.jme}>
                  <InputField
                    variant="outlined"
                    value={jme_group}
                    onChange={e => dispatchSet(draftActions.jme(e.target.value))}
                    disabled={disabled}
                  />
                </Label>
              </Styles.SetRow>
            </Styles.SetBody>
          </TableCell>
        </TableRow>
        <SubTableWrapper>
          <MemoizedTrayTable set={set} dispatchSet={dispatchSet} disabled={disabled} />
        </SubTableWrapper>
      </TableBody>
    </Table>
  );
};

export default SetTable;
